import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CoachesRoutingModule } from './coaches-routing.module';
import { BootstrapCoachesComponent } from './components/bootstrap-coaches/bootstrap-coaches.component';
import { CommonPageComponentsModule } from '../common-page-components/common-page-components.module';
import { ServicesModule } from '../library/components/services/services.module';
import { CoreModule } from '../library/core.module';
import { FilterCoachesService } from './services/filter-coaches.service';

@NgModule({
  declarations: [BootstrapCoachesComponent],
  imports: [
    CommonModule,
    CoachesRoutingModule,
    CommonPageComponentsModule,
    ServicesModule,
    CoreModule
  ],
  providers:[
    FilterCoachesService
  ]
})
export class CoachesModule { }
